export default __webpack_public_path__ + "static/media/Talent_The_Pawn.0f43a1f2.png";